import { useState } from 'react'
import Select from 'react-select';
import Switch from 'react-switch';
import CustomColumn from '../../../../customControl/CustomColumn';
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { alphaSpace, getDateCombination, isImageValidPng } from '../../../commonClass/CommonValidation';
import { ImageUpload } from '../../../../ImageUpload/ImageCommon';
import { getactivitymanagebyid } from '../../ActivitymasterUtility';
import { getActivityManageId } from '../ManageActivityMaster';

const getHoursAndTime = (time) => {
    const date = new Date(time);
    const hours = date.getHours() || 0;
    const minutes = date.getMinutes() || 0;
    return { hours, minutes }
}

const ActivityVariants = ({ activityData, dropdownData, setSelectTab, setActivityInfo, disabled, editDisabled, setEditDisabled }) => {
    const dispatch = useDispatch();
    const [formValue, setFormValue] = useState({
        ...activityData?.activityInfo,
        ...getHoursAndTime(activityData?.activityInfo?.durationTime),
        inclusionIds: typeof activityData?.activityInfo?.inclusionIds === "string" ? activityData?.activityInfo?.inclusionIds.split(",")
            .map(id => Number(id.trim())).filter(id => !isNaN(id)) : activityData?.activityInfo?.inclusionIds,
        durationDayNo: activityData?.activityInfo?.durationDayNo || 0
    });
    const [modalShow, setModalShow] = useState(false);
    const [formErrors, setFormErrors] = useState({})


    const getNumberList = (startWith = 1, end = 15) =>
        Array.from({ length: end - startWith + 1 }, (_, i) => {
            const val = startWith + i;
            return { label: val, value: val };
        });

    const daysList = getNumberList(0, 15);
    const hoursList = getNumberList(0, 23);
    const minuteList = getNumberList(0, 59);

    const handleOnChanges = (name, value) => {
        setEditDisabled(false);
        setFormValue({ ...formValue, [name]: value });
        setFormErrors({})
    }

    const handleisActive = (e) => {
        if (formValue.ActivityInfoId <= 0 || !formValue.ActivityInfoId) {
            handleOnChanges('isActive', e);
        } else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setModalShow(false);
            handleOnChanges('isActive', !formValue.isActive);
        }
        else {
            setModalShow(false);
        }
    }

    const handleImageUpload = (e) => {
        if (e?.target?.files?.length > 0) {
            setEditDisabled(false);
            const file = e.target.files?.[0];
            const fileName = getDateCombination(file?.name);
            const filePath = `CMS/Activty/${fileName}`;
            const path = `CMS/Activity/`;

            const fileSize = (file?.size / 1024) / 1024;

            const length = file?.type?.split('/')?.length
            const fileType = file?.type?.split('/')?.[length - 1]?.toString()?.toLowerCase();
            setFormErrors({})
            setFormValue((form) => ({
                ...form,
                imageName: fileName,
                imagePath: filePath,
                imageFile: file,
                IsNeedToUpdate: true,
                Path: file ? path : "",
                size: file ? fileSize : 0,
                type: file ? fileType : "",
            }))
        }
    }

    const validation = () => {
        let errorMessage = {}
        let IsError = true

        if (formValue?.durationDayNo <= 0 && formValue?.hours <= 0 && formValue?.minutes <= 0) {
            errorMessage = { ...errorMessage, durationDayNo: "Input is mandatory, cannot leave blank" }
            IsError = false
        }

        if (formValue?.inclusionIds?.length <= 0 || !formValue?.inclusionIds) {
            errorMessage = { ...errorMessage, InclusionIds: "Kindly select Inclusion" }
            IsError = false
        }

        if (formValue?.activityTypeId <= 0 || !formValue?.activityTypeId) {
            errorMessage = { ...errorMessage, Isthisactivityfor: "Kindly select Is this activity for " }
            IsError = false
        }

        if (formValue.IsNeedToUpdate > 0 && formValue.size > 5) {
            errorMessage = { ...errorMessage, imageName: "Please upload an image smaller than 5 MB." }
            IsError = false
        } else if (formValue.IsNeedToUpdate && !isImageValidPng(formValue.imageFile.name)) {
            errorMessage = { ...errorMessage, imageName: "Only PNG file type is accepted." }
            IsError = false
        }
        setFormErrors(errorMessage)
        return IsError
    }

    const saveData = async () => {
        if (validation()) {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user = GetLocalStorage();
                const payloadData = {
                    ActivityInfoId: 0,
                    ActivityBasicInfoId: getActivityManageId(),
                    DurationDayNo: formValue.durationDayNo,
                    DurationTime: `2026-01-01T${formValue.hours === 0 ? '00' : formValue.hours > 0 && formValue.hours <= 9 ? '0' + formValue.hours : formValue.hours}:${formValue.minutes === 0 ? '00' : formValue.minutes > 0 && formValue.minutes <= 9 ? '0' + formValue.minutes : formValue.minutes}:00`,
                    InclusionIds: formValue.inclusionIds,
                    ActivityTypeId: formValue.activityTypeId,
                    Descriptions: formValue.descriptions,
                    imageName: formValue.imageName || formValue.imageName,
                    imagePath: formValue.imagePath || formValue.imagePath,
                    IsActive: formValue.isActive,
                    UserId: user?.userMasterID
                }

                const upsertactivityinfo = await postUsersData('/master/v1/upsertactivityinfo', payloadData);
                if (upsertactivityinfo?.status) {
                    formValue.IsNeedToUpdate && await ImageUpload(formValue.Path, formValue.imageName, formValue.imageFile);
                    const activityInfoId = getActivityManageId() || activityData?.activityInfo.activityBasicInfoId
                    const retrieveData = await getactivitymanagebyid(activityInfoId);
                    setActivityInfo({
                        ...activityData,
                        activityInfo: {
                            ...retrieveData?.activityInfo,
                            activityBasicInfoId: retrieveData?.BasicInformationForm?.ActivityBasicInfoId
                        },
                        activityInfoInclusion: retrieveData?.activityInfoInclusion
                    });
                    dispatch({ type: 'ALERTING', message: upsertactivityinfo?.message });
                    setSelectTab(3);
                }
                else {
                    dispatch({ type: 'ALERTING', message: upsertactivityinfo?.message });
                }
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        }
    }

    return (
        <div className="my-5">
            <div className="container-fluid form_border my-2 py-3">
                <div className="row">

                    <CustomColumn colNum={10} labelText='Activity' labelId='VariantsName' isRequired >
                        <input
                            type="text"
                            className='form-control'
                            name="VariantsName"
                            id="VariantsName"
                            value={activityData?.activityInfo?.ActivityName}
                            disabled={true}
                            placeholder='Activity Name'
                        />
                    </CustomColumn>

                    <CustomColumn classlabel="align-content-center" colNum={10} labelText='Duration of Activity Experience' labelId='ExperienceDuration' isRequired>
                        <div className="row g-2">
                            <div className='days col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12'>
                                <div className='text-muted'> Days </div>
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='Days'
                                    options={daysList}
                                    value={daysList.find((val) => val.value === formValue.durationDayNo)}
                                    onChange={(val) => { handleOnChanges('durationDayNo', val.value) }}
                                    isSearchable
                                    isDisabled={disabled ? true : false}
                                    placeholder='Days'
                                />
                                {/* {formErrors?.durationDayNo && <div className="text-danger text-start fs_14">{formErrors?.durationDayNo}</div>} */}
                            </div>
                            <div className='hours col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12'>
                                <div className='text-muted'> Hours </div>
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='Hours'
                                    options={hoursList}
                                    value={hoursList.find((val) => val.value === formValue.hours)}
                                    onChange={(val) => { handleOnChanges('hours', val.value) }}
                                    isSearchable
                                    isDisabled={disabled ? true : false}
                                    placeholder='Hours'
                                />
                                {/* {formErrors?.hours && <div className="text-danger text-start fs_14">{formErrors?.hours}</div>} */}
                            </div>
                            <div className='minutes col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12'>
                                <div className='text-muted'> Minutes </div>
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='Minutes'
                                    options={minuteList}
                                    value={hoursList.find((val) => val.value === formValue.minutes)}
                                    onChange={(val) => { handleOnChanges('minutes', val.value) }}
                                    isSearchable
                                    isDisabled={disabled ? true : false}
                                    placeholder='Minutes'
                                />
                                {/* {formErrors?.minutes && <div className="text-danger text-start fs_14">{formErrors?.minutes}</div>} */}
                            </div>
                        </div>
                        {formErrors?.durationDayNo && <div className="text-danger text-start fs_14">{formErrors?.durationDayNo}</div>}
                    </CustomColumn>
                </div>

                <div className="row">
                    <CustomColumn colNum={10} labelText='Inclusion' labelId='GeneralInclusions' isRequired >
                        <Select
                            className="dropdown select_dropdown"
                            inputId='Inclusions'
                            options={activityData?.activityInfoInclusion}
                            value={activityData?.activityInfoInclusion?.filter((val) => formValue?.inclusionIds?.includes(val.value))}
                            onChange={(val) => {
                                handleOnChanges('inclusionIds', val.map((inclusion) => inclusion.value))
                            }}
                            isMulti
                            isSearchable
                            isDisabled={disabled ? true : false}
                            placeholder='Inclusions'
                        />
                        {formErrors?.InclusionIds && <div className="text-danger text-start fs_14">{formErrors?.InclusionIds}</div>}
                    </CustomColumn>
                </div>

                <div className="row">
                    <CustomColumn colNum={10} labelText='Is this activity for' labelId='ActivityId' isRequired>
                        <Select
                            className="dropdown select_dropdown"
                            inputId='ActivityTypeId'
                            options={dropdownData?.activityTypesOption}
                            value={dropdownData?.activityTypesOption.find((val) => val.value === formValue.activityTypeId)}
                            onChange={(val) => { handleOnChanges('activityTypeId', val.value) }}
                            isSearchable
                            isDisabled={disabled ? true : false}
                        />
                        {formErrors?.Isthisactivityfor && <div className="text-danger text-start fs_14">{formErrors?.Isthisactivityfor}</div>}
                    </CustomColumn>
                </div>

                <div className="row">
                    <CustomColumn colNum={10} labelText='Banner' labelId='BannerImages'>
                        <div className="input-group">
                            <input
                                type="file"
                                className='form-control btn_add'
                                id="BannerImages"
                                disabled={disabled ? true : false}
                                placeholder='Drop to upload your file'
                                onChange={(e) => handleImageUpload(e)}
                            />
                            <label
                                htmlFor="BannerImages"
                                className='input-group-text'
                            >
                                Browse
                            </label>
                        </div>
                        {formValue?.ImageName || formValue?.imageName && <div className=" text-start fs_14">{formValue?.imageName || formValue?.imageName}</div>}
                        {formErrors?.imageName && <div className="text-danger text-start fs_14">{formErrors?.imageName}</div>}
                    </CustomColumn>
                </div>

                <div className="row">
                    <CustomColumn colNum={10} labelText='Detail Descriptions' labelId='DetailDescriptions'>
                        <textarea
                            className='form-control'
                            name="descriptions"
                            id="descriptions"
                            maxLength={100}
                            value={formValue?.descriptions}
                            onChange={(e) => { handleOnChanges(e.target.name, alphaSpace(e.target.value)) }}
                            disabled={disabled ? true : false}
                            placeholder='Detail Descriptions for Activity'
                            rows={3}
                        />
                    </CustomColumn>

                    <CustomColumn colNum={10} labelText='Activity status' labelId='VariantsStatus'>
                        <Switch
                            onChange={handleisActive}
                            checked={formValue.isActive}
                            defaultChecked
                            className="react-switch"
                            disabled={disabled ? true : false}
                        />

                        <ConfirmationModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            noconfirm={() => handleConfirmation(false)}
                            yesconfirm={() => handleConfirmation(true)}
                        />
                    </CustomColumn>
                </div>

                <div className="text-center mt-2">
                    <button
                        type="button"
                        className='btn btn-primary'
                        disabled={editDisabled}
                        onClick={() => { saveData() }}
                    >
                        Save & Proceed
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ActivityVariants
